module.exports = __webpack_public_path__ + "img/chinesecompany82.2714fccf.png";